import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { NullableString } from '@app/shared/models/nullable';
import { Strings } from '@app/shared/constants';

@Component({
  selector: 'app-externe-individual-link',
  templateUrl: './externe-individual-link.component.html',
  styleUrls: ['./externe-individual-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExterneIndividualLinkComponent implements OnChanges {
  @Input() externalLink: NullableString = null;
  @Input() disabled = false;
  @Output() textchange = new EventEmitter<string>();

  private _link: NullableString = '';

  public externalLinkFormControl = new FormControl('', {
    validators: [this.checkURL()],
    updateOn: 'blur',
  });
  public view = true;

  constructor(private eRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public clickout(event: any): void {
    const inputElement = event.target as HTMLElement;
    const isClickInsideInput = inputElement.closest('input') !== null;
    if (!isClickInsideInput && this._link !== this.externalLinkFormControl.value && !this.eRef.nativeElement.contains(event.target)) {
      if(this.externalLinkFormControl.errors === null || this.externalLinkFormControl.errors?.length === 0){
        this.externalLink = this.externalLinkFormControl.value;
        this.view = true;
        this.textchange.emit(this.externalLink as string);
      }
    }
  }

  public ngOnChanges(): void {
    this.externalLinkFormControl.setValue(this.externalLink);
    this._link = this.externalLink;
  }

  public toggleEdit(): void {
    this.view = !this.view;
  }

  public cancelEdit(): void {
    this.externalLinkFormControl.setValue(this._link);
    this.view = true;
  }

  public clearLink(): void {
    this.externalLink = '';
    this.externalLinkFormControl.setValue('');
    this.textchange.emit('');
  }

  public linkChanged(value: string): void {
    this.externalLinkFormControl.setValue(value);
  }

  private checkURL(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const expression = Strings.urlRegex;
      const regex = new RegExp(expression);

      if (control.value === null || control.value === '' || control.value.match(regex)) {
        return null;
      }

      return { invalidUrl: true };
    };
  }
}
